import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib/store';
import * as actions from './get-receipt.actions';
import { GetReceiptState } from './get-receipt.state';

/**
 * getReceipt initial state
 */
export const getReceiptInitialState: GetReceiptState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for GetReceipt Store
 */
export const getReceiptReducerFeatures: ReducerTypes<GetReceiptState, ActionCreator[]>[] = [
  on(actions.setGetReceipt, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateGetReceipt, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetGetReceipt, () => getReceiptInitialState),

  on(actions.cancelGetReceiptRequest, (state, action) => asyncStoreItemAdapter.resolveRequest(state, action.requestId)),

  on(actions.failGetReceipt, (state, payload) => asyncStoreItemAdapter.failRequest(state, payload.requestId)),

  on(actions.setGetReceiptFromApi, actions.updateGetReceiptFromApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * GetReceipt Store reducer
 */
export const getReceiptReducer = createReducer(getReceiptInitialState, ...getReceiptReducerFeatures);
